// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum PDFLayoutBehavior {
  DownscalingAndMaxBox = 0,
  DownscalingAndCropBox = 1,
  FitAndCropBox = 2
}
